import axios from "axios";
import authHeader from "@/services/auth-header";

class PrintSetItemService {
  get() {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/PrintSetItem`,
        {
            headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new PrintSetItemService();
